import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
const serviceName = "foodie-access-service";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

export const GetAccessCodeById = createAsyncThunk('accessCode/getAccessCodeById ', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${serviceName}/v1/by-id/${params}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateAccessCode = createAsyncThunk("accessCode/createAccessCode",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(`${serviceName}/v1/create`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetAccessCodeQR = createAsyncThunk('accessCode/getAccessCodeQR ', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${serviceName}/v1/qr-code/${params}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});


export const CancelAccessCode = createAsyncThunk("accessCode/cancelAccessCode",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(`${serviceName}/v1/cancel`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});
